import { Component } from '@angular/core';
import { FinancialDashboardChartComponent } from "../financial-dashboard-chart/financial-dashboard-chart.component";

@Component({
  selector: 'app-summary-management',
  standalone: true,
  imports: [FinancialDashboardChartComponent],
  templateUrl: './summary-management.component.html',
  styleUrl: './summary-management.component.css'
})
export class SummaryManagementComponent {
}
